<template>
  <div class="">
    <div class="now-result mb-2">
      <div class="result-head p-2 mt-2 mb-2">
        <h2>ງວດປະຈຳວັນທີ່ {{ lottoDate | date }}</h2>
      </div>
      <div class="result-body px-4">
        <div class="result-top">
          <h1 class="mb-0">
            <EmptyNumbers v-if="status===0" />
            <SpinNumbers v-else-if="status===1" :startShow="startShow" :resultNumbers="resultNumbers" />
            <ShowSuccessResult v-else-if="status===2" :resultNumbers="resultNumbers" />
          </h1>
          <h3 class="mb-0 mt-2">ເວລາອອກເລກ {{showTime}}</h3>
        </div>
      </div>

      <div class="result-body px-4 pt-2 pb-3">
        <table class="table table-bordered">
          <tr>
            <td style="width: 50%;">
              <div class="left">ເລກ 5 ໂຕ</div>
            </td>
            <td>
              <div class="right">{{ Digit5 }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="left">ເລກ 4 ໂຕ</div>
            </td>
            <td>
              <div class="right">{{ Digit4 }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="left">ເລກ 3 ໂຕ</div>
            </td>
            <td>
              <div class="right">{{ Digit3 }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="left">ເລກ 2 ໂຕ</div>
            </td>
            <td>
              <div class="right">{{ Digit2Top }}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="left">ເລກ 1 ໂຕ</div>
            </td>
            <td>
              <div class="right">{{ Digit1 }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

import EmptyNumbers from './EmptyNumbers.vue'
import SpinNumbers from './SpinNumbers.vue'
import ShowSuccessResult from './ShowSuccessResult.vue'

export default {
  name: 'TodayResult',
  components: {
    EmptyNumbers,
    SpinNumbers,
    ShowSuccessResult
  },
  data() {
    return {
      data: null,
      status: 0,
      Interval: null,
      setTimeout: null
    }
  },
  computed: {
    lottoDate() {
      if (this.data) {
        return this.data.lotto_date
      } else {
        return ''
      }
    },
    startShow() {
      if (this.data) {
        return this.data.show_result
      } else {
        return null
      }
    },
    resultNumbers() {
      if (this.results) {
        return this.results.digit5
      } else {
        return null
      }
    },
    results() {
      if (this.data) {
        return this.data.results
      } else {
        return null
      }
    },
    Digit5() {
      if (this.results && this.status === 2) {
        return this.results.digit5
      } else {
        return '-----'
      }
    },
    Digit4() {
      if (this.results && this.status === 2) {
        return this.results.digit4
      } else {
        return '----'
      }
    },
    Digit3() {
      if (this.results && this.status === 2) {
        return this.results.digit3
      } else {
        return '---'
      }
    },
    Digit2Top() {
      if (this.results && this.status === 2) {
        return this.results.digit2_top
      } else {
        return '--'
      }
    },
    Digit1() {
      if (this.results && this.status === 2) {
        return this.results.digit1
      } else {
        return '-'
      }
    },
    Digit2Bottom() {
      if (this.results && this.status === 2) {
        return this.results.digit2_bottom
      } else {
        return '--'
      }
    },
    Digit2Special() {
      if (this.results && this.status === 2) {
        return this.results.digit2_special
      } else {
        return '--'
      }
    },
    showTime() {
      if (this.results) {
        return moment(this.data.show_result).format("HH:mm")
      } else {
        return '--'
      }
    }
  },
  methods: {
    loadResult() {
      LottoService.nowResult().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
          this.calProcess()
        }
      })
    },
    calProcess() {
      let successTime = moment(this.data.show_result).add(1, 'seconds')
      // ยังไม่ถึงเวลาเริ่มหมุน
      if (moment().isBefore(this.data.start_spin)) {
        this.status = 0
        clearTimeout(this.setTimeout)
        let diff = moment(this.data.start_spin).diff(moment(), 'milliseconds') + 1000
        this.setTimeout = setTimeout(() => {
          this.calProcess()
        }, diff)
      } else
        // อยู่ระหว่างหมุนออกรางวัล
        if (this.data.start_spin && this.data.show_result && moment().isBetween(this.data.start_spin, successTime)) {
          this.status = 1
          clearTimeout(this.setTimeout)
          let diff = moment(this.data.show_result).diff(moment(), 'milliseconds') + 1000
          this.setTimeout = setTimeout(() => {
            this.calProcess()
          }, diff)
        } else
          // กำลังหมุนออกรางวัล แต่ไม่ได้ตั้งเวลาออกผล
          if (moment().isAfter(this.data.start_spin) && !this.data.show_result) {
            this.status = 1
          } else
            // ถึงเวลาออกผลแล้ว
            if (moment().isAfter(this.data.show_result)) {

              let results = this.data.results
              if (results.digit5) {
                // ออกผลเสร็จหมดแล้ว
                if (moment().isAfter(successTime)) {
                  this.status = 2
                } else {
                  // กำลังอยู่ในขั้นตอนแสดงผลที่ล่ะชุดตัวเลข
                  let diff = moment(successTime).diff(moment(), 'milliseconds') + 500
                  this.setTimeout = setTimeout(() => {
                    this.calProcess()
                  }, diff)
                }
                // เลยเวลาออกผล แต่ไม่มีผลมา
              } else {
                this.status = 1
                clearTimeout(this.setTimeout)
                this.setTimeout = setTimeout(() => {
                  this.loadResult()
                }, 10000)
              }

            }
    }
  },
  created() {
    this.loadResult()
    this.Interval = setInterval(() => {
      this.loadResult()
    }, 60000)
  },
  filters: {
    date(param) {
      if (param) {
        return moment(param).format("LL")
      } else {
        return '-'
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}

</script>
<style lang="scss">
.now-result {
  border: 5px solid darkgoldenrod;
  background-color: #CBCBCB;

  .result-head {
    h2 {
      text-align: center;
      font-size: 1.3rem;
      margin: 0;
      font-weight: bold;
      color: #032C98;
    }
  }

  .result-body {
    .result-top {
      display: flex;
      flex-direction: column;
      align-items: center;
      align-content: center;

      h1 {
        text-align: center;
        font-size: 4rem;
        font-weight: bold;
        line-height: 1.1;

        span {
          color: #FFF;
          text-align: center;
          padding: 0;
          display: flex;

          span {
            display: block;
            width: 64px;
            height: 79px;
            margin: 0 2px;
            background-color: #696969;
            border-radius: 10px;
            border: 2px solid #FFF;
          }
        }
      }
      h3 {
        text-align: center;
        font-size: 1.1rem;
        font-weight: bold;
        color: #032C98;
        padding: 4px 25px;
      }
    }

    .table {
      background-color: #CBCBCB;
      text-align: center;
      margin-bottom: 0px;
      tr {
        td {
          padding: 0;
          font-size: 1.5rem;
          border: 2px solid #CBCBCB;
          vertical-align: middle;

          div {
            background-color: #EEE;
          }

          div.left {
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
          }

          div.right {
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
          }
        }
      }
    }
  }
}
</style>
